import { Pipe, PipeTransform } from '@angular/core';
import {SubtitlesService} from "../core";

@Pipe({
    name: 'longDayName'
})
export class LongDayNamePipe implements PipeTransform {
    constructor(private subtitles: SubtitlesService) {
    }

    transform(value: number) : string {
        switch (value) {
            case 0:
                return this.subtitles.setSubtitle(589);
            case 1:
                return this.subtitles.setSubtitle(893);
            case 2:
                return this.subtitles.setSubtitle(707);
            case 3:
                return this.subtitles.setSubtitle(234);
            case 4:
                return this.subtitles.setSubtitle(515);
            case 5:
                return this.subtitles.setSubtitle(702);
            case 6:
                return this.subtitles.setSubtitle(444);
            default:
                return '';
        }
    }
}
